var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.617,
    height: 45.617,
    viewBox: "0 0 45.617 45.617",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-2.101 -2.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_135420",
    "data-name": "Path 135420",
    d: "M26.359,11.731a1.641,1.641,0,0,0-2.32,0L11.731,24.038a1.641,1.641,0,1,0,2.321,2.321L26.359,14.051a1.641,1.641,0,0,0,0-2.32Z",
    transform: "translate(5.865 5.865)",
    fill: "#839cb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135421",
    "data-name": "Path 135421",
    d: "M19.846,13.923a4.923,4.923,0,1,0-4.923,4.923A4.923,4.923,0,0,0,19.846,13.923Zm-6.564,0a1.641,1.641,0,1,1,1.641,1.641A1.641,1.641,0,0,1,13.282,13.923Z",
    transform: "translate(5.063 4.422)",
    fill: "#839cb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135422",
    "data-name": "Path 135422",
    d: "M20.923,17a4.923,4.923,0,1,0,4.923,4.923A4.923,4.923,0,0,0,20.923,17Zm0,6.564a1.641,1.641,0,1,1,1.641-1.641A1.641,1.641,0,0,1,20.923,23.564Z",
    transform: "translate(8.909 9.55)",
    fill: "#839cb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135423",
    "data-name": "Path 135423",
    d: "M45.8,20.268l-1.874-1.876a3.259,3.259,0,0,1-.962-2.32v-2.65A6.564,6.564,0,0,0,36.4,6.858h-2.65a3.259,3.259,0,0,1-2.32-.962L29.55,4.023a6.564,6.564,0,0,0-9.281,0L18.393,5.9a3.259,3.259,0,0,1-2.32.962h-2.65a6.564,6.564,0,0,0-6.564,6.564v2.65a3.259,3.259,0,0,1-.962,2.32L4.023,20.268a6.564,6.564,0,0,0,0,9.281L5.9,31.426a3.259,3.259,0,0,1,.962,2.32V36.4a6.564,6.564,0,0,0,6.564,6.564h2.65a3.259,3.259,0,0,1,2.32.962L20.268,45.8a6.564,6.564,0,0,0,9.281,0l1.876-1.874a3.259,3.259,0,0,1,2.32-.962H36.4A6.564,6.564,0,0,0,42.96,36.4v-2.65a3.259,3.259,0,0,1,.962-2.32L45.8,29.55a6.564,6.564,0,0,0,0-9.281Zm-2.32,6.961L41.6,29.105a6.513,6.513,0,0,0-1.923,4.641V36.4A3.282,3.282,0,0,1,36.4,39.678h-2.65A6.52,6.52,0,0,0,29.105,41.6L27.23,43.475a3.282,3.282,0,0,1-4.641,0L20.715,41.6a6.528,6.528,0,0,0-4.642-1.923h-2.65A3.282,3.282,0,0,1,10.14,36.4v-2.65a6.52,6.52,0,0,0-1.923-4.641L6.343,27.23a3.282,3.282,0,0,1,0-4.641l1.874-1.874a6.528,6.528,0,0,0,1.923-4.642v-2.65a3.282,3.282,0,0,1,3.282-3.282h2.65a6.52,6.52,0,0,0,4.641-1.923l1.876-1.874a3.282,3.282,0,0,1,4.641,0L29.1,8.217a6.528,6.528,0,0,0,4.642,1.923H36.4a3.282,3.282,0,0,1,3.282,3.282v2.65A6.52,6.52,0,0,0,41.6,20.713l1.874,1.876A3.282,3.282,0,0,1,43.475,27.23Z",
    transform: "translate(0)",
    fill: "#839cb9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersent);
export default __webpack_public_path__ + "static/media/persent.05ef7bb0d64cd80bbf7f9883dd7e268f.svg";
export { ForwardRef as ReactComponent };